import axios from 'axios';

// Функция за вземане на OpenAI API ключ от сървъра
const getApiKey = async () => {
    try {
        const response = await axios.get('/openai/api-key');
        return response.data.apiKey;
    } catch (error) {
        console.error('Error fetching API key:', error);
        throw new Error('Failed to get API key');
    }
};

const generateText = async (contentType, tone, selectedLanguages) => {
  try {
    const apiKey = await getApiKey();
    const response = await axios.post(
      'https://api.openai.com/v1/chat/completions',
      {
        model: "gpt-4",  // Model to use
        messages: [
          { role: 'system', content: 'You are a helpful assistant.' },  // System setup
          { role: 'user', content: `Create a text on the topic: ${contentType}, with a tone of ${tone} in language ${selectedLanguages[0]}` },  // Request including selected language
        ],
        //max_tokens: 50,  // Set token limit
        temperature: 0.7,  // Controls creativity
      },
      {
        headers: {
          'Authorization': `Bearer ${apiKey}`,  // Authorization with API key
          'Content-Type': 'application/json',
        },
      }
    );

    return response.data.choices[0].message.content;  // Return generated content
  } catch (error) {
    console.error('Error generating text:', error);
  }
};

export default generateText;
